import { customAlphabet } from 'nanoid';

export const createUniqueId = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-', 24);
